import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { HomePageLayoutBlueprint } from '@backstage/plugin-home-react/alpha';
import { Content, Header, Page } from '@backstage/core-components';
import {
  HomePageRecentlyVisited,
  HomePageStarredEntities,
  HomePageToolkit,
} from '@backstage/plugin-home';
import homePlugin from '@backstage/plugin-home/alpha';
import { useStyles } from '../theme/styles';
import { useTheme } from '@material-ui/core';
import { useCallback, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SearchBarBase } from '@backstage/plugin-search-react';
import backStageBlackIcon from '../theme/logo/Icon_Black.svg';
import backstageGradientIcon from '../theme/logo/Icon_Gradient.svg';
import WikiIcon from '@material-ui/icons/MenuBook';
import DescriptionIcon from '@material-ui/icons/Description';
import Grid from '@material-ui/core/Grid';
import { WelcomeCard } from './welcomeCard';

function HomeSearchBar() {
  const [query, setQuery] = useState('');
  const inputRef = useRef<HTMLInputElement | null>(null);
  const navigate = useNavigate();

  const handleSubmit = useCallback(() => {
    const rawQuery = inputRef.current?.value?.trim() ?? '';
    navigate(`/search?query=${encodeURIComponent(rawQuery)}`);
  }, [navigate]);

  return (
    <SearchBarBase
      value={query}
      onChange={setQuery}
      onSubmit={handleSubmit}
      inputProps={{ ref: inputRef }}
    />
  );
}

export const customHomePageModule = createFrontendModule({
  pluginId: 'home',
  extensions: [
    (homePlugin.getExtension('page:home') as any).override({
      params: {
        path: '/',
      },
    }) as any,
    HomePageLayoutBlueprint.make({
      params: {
        loader: async () =>
          function CustomHomePageLayout() {
            const theme = useTheme();
            const classes = useStyles();

            return (
              <Page themeId="home">
                <Header title="Launchpad" pageTitleOverride="Home" />
                <Content>
                  <HomeSearchBar />
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <WelcomeCard />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <HomePageToolkit
                        title="Quick Links"
                        tools={[
                          {
                            url: 'https://sca.sharepoint.com/sites/GRP-IT-Infrastructure/SitePages/Requesting-Work-From-Infrastructure-Services.aspx',
                            label: 'Sharepoint',
                            icon: (
                              <DescriptionIcon
                                className={classes.quickLinkIcon}
                              />
                            ),
                          },
                          {
                            url: 'https://dev.azure.com/essity-projects/Essity%20Infrastructure%20Services/_wiki/wikis/CET-Wiki/4462/Cloud-Team-Wiki',
                            label: 'Wiki',
                            icon: (
                              <WikiIcon className={classes.quickLinkIcon} />
                            ),
                          },
                          {
                            url: 'https://backstage.io/docs/overview/what-is-backstage',
                            label: 'Learn Backstage',
                            icon: (
                              <img
                                src={
                                  theme.palette.type === 'dark'
                                    ? backstageGradientIcon
                                    : backStageBlackIcon
                                }
                                alt="backstage logo"
                                className={classes.backstageIcon}
                              />
                            ),
                          },
                        ]}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <HomePageStarredEntities />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <HomePageRecentlyVisited />
                    </Grid>
                  </Grid>
                </Content>
              </Page>
            );
          },
      },
    }),
  ],
});
